import AdvanceTable from '../../components/base/AdvanceTable';
import { Link } from 'react-router-dom';
import AdvanceTableFooter from '../../components/base/AdvanceTableFooter';
import Avatar from '../../components/base/Avatar';
import { ProgressBar } from 'react-bootstrap';
import RevealDropdown, {
  RevealDropdownTrigger
} from '../../components/base/RevealDropdown';
import ActionDropdownItems from '../../components/common/ActionDropdownItems';
import Badge from '../../components/base/Badge';

export const projectListTableColumns = [
  {
    accessorKey: 'jobIdShort',
    header: 'Job ID',
    cell: ({ row: { original } }) => {
      return (
        <Link
          to={`/apps/project-management/project-details/${original.jobId}`}
          className="text-decoration-none fw-bold fs-8"
          title={original.jobId} // hover arată full id
        >
          {original.jobIdShort}
        </Link>
      );
    },
    meta: {
      cellProps: { className: 'white-space-nowrap py-4' },
      headerProps: { style: { width: '12%' } }
    }
  },

  {
    accessorKey: 'name',
    header: 'Project Name',
    cell: ({ row: { original } }) => {
      console.log(original);
      console.log();
      return (
        <Link
          to={`/apps/standard/${original.standardId}`}
          className="text-decoration-none fw-bold fs-8"
        >
          {original.productLabel}
        </Link>
      );
    },
    meta: {
      cellProps: { className: 'white-space-nowrap py-4' },
      headerProps: { style: { width: '10%' } }
    }
  },

  {
    accessorKey: 'plannedLength',
    header: 'Planned Length (m)',
    cell: ({ row: { original } }) => {
      return (
        <span className="ps-3 fs-9 text-900 white-space-nowrap py-4">
          {Number(original.plannedLength || 0).toLocaleString()}
        </span>
      );
    },

    meta: {
      cellProps: { className: 'ps-3 py-4' },
      headerProps: { style: { width: '12%' }, className: 'ps-3' }
    }
  },

  {
    header: 'Start date',
    accessorKey: 'start',
    meta: {
      cellProps: { className: 'ps-3 fs-9 text-900 white-space-nowrap py-4' },
      headerProps: { style: { width: '14%' }, className: 'ps-3' }
    }
  },

  {
    header: 'Deadline',
    accessorKey: 'deadline',
    meta: {
      cellProps: { className: 'ps-3 fs-9 text-900 white-space-nowrap py-4' },
      headerProps: { style: { width: '14%' }, className: 'ps-3' }
    }
  },

  {
    accessorKey: 'task',
    header: 'Task',
    meta: {
      cellProps: { className: 'ps-3 text-900 py-4' },
      headerProps: { style: { width: '8%' }, className: 'ps-3' }
    }
  },

  {
    id: 'progressTokens',
    header: 'Progress',
    cell: ({ row: { original } }) => {
      const { progressTokens } = original;

      return (
        <>
          <p className="text-800 fs-10 mb-0">
            {progressTokens.min} / {progressTokens.max}
          </p>
          <ProgressBar
            now={(progressTokens.min / progressTokens.max) * 100}
            style={{ height: 3 }}
            variant="success"
          />
        </>
      );
    },
    meta: {
      cellProps: { className: 'ps-3 py-4' },
      headerProps: { style: { width: '10%' }, className: 'ps-3' }
    }
  },

  {
    id: 'status',
    header: 'Status',
    accessorFn: ({ status }) => status.label,
    cell: ({ row: { original } }) => {
      const { status } = original;
      return (
        <Badge variant="phoenix" bg={status.type}>
          {status.uiLabel || status.label}
        </Badge>
      );
    },
    meta: {
      cellProps: { className: 'ps-8 py-4' },
      headerProps: { style: { width: '10%' }, className: 'ps-8' }
    }
  },

  {
    id: 'action',
    cell: () => (
      <RevealDropdownTrigger>
        <RevealDropdown>
          <ActionDropdownItems />
        </RevealDropdown>
      </RevealDropdownTrigger>
    ),
    meta: {
      headerProps: { style: { width: '5%' }, className: 'text-end' },
      cellProps: { className: 'text-end' }
    }
  }
];

const ProjectListTable = () => {
  return (
    <div className="border-bottom">
      <AdvanceTable
        tableProps={{ className: 'phoenix-table border-top border-200 fs-9' }}
      />
      <AdvanceTableFooter pagination className="py-3" />
    </div>
  );
};

export default ProjectListTable;
